// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3_I_j","errorLogs":"EditorFooter_errorLogs__1TCTL"};